import React, { MouseEvent, FunctionComponent } from 'react'
import classNames from 'classnames'

import styles from './icon.module.scss'

export enum Icons {
  'activity' = 'activity',
  'alert-octagon' = 'alert-octagon',
  'bell' = 'bell',
  'book' = 'book',
  'calendar' = 'calendar',
  'check-square' = 'check-square',
  'check' = 'check',
  'chevron-down' = 'chevron-down',
  'chevron-left' = 'chevron-left',
  'chevron-right' = 'chevron-right',
  'chevron-up' = 'chevron-up',
  'chevrons-right' = 'chevrons-right',
  'cross' = 'cross',
  'discord' = 'discord',
  'edit' = 'edit',
  'external-link' = 'external-link',
  'eye-off' = 'eye-off',
  'eye' = 'eye',
  'home' = 'home',
  'info' = 'info',
  'loader' = 'loader',
  'log-out' = 'log-out',
  'mail' = 'mail',
  'map' = 'map',
  'menu' = 'menu',
  'newfile' = 'newfile',
  'package' = 'package',
  'phone' = 'phone',
  'play-circle' = 'play-circle',
  'plus-circle' = 'plus-circle',
  'plus' = 'plus',
  'refresh' = 'refresh',
  'search' = 'search',
  'settings' = 'settings',
  'shopping-bag' = 'shopping-bag',
  'star' = 'star',
  'trending-up' = 'trending-up',
  'upload' = 'upload',
  'user' = 'user',
}

interface IDefaultProps {
  styleType: 'primary' | 'success'
  className: string
  onClick: (event: MouseEvent) => void
}

interface IProps extends Partial<IDefaultProps> {
  type: Icons
}

const defaultProps: IDefaultProps = {
  styleType: 'primary',
  onClick: () => {},
  className: '',
}

const Icon: FunctionComponent<IProps> = ({
  onClick,
  type,
  styleType,
  className,
}) => {
  return (
    <span
      onClick={onClick}
      className={classNames(styles['icon'], {
        [styles[`icon__${type}`]]: type,
        [styles[`icon__${styleType}`]]: styleType,
        [className as string]: className,
      })}
    />
  )
}

Icon.defaultProps = defaultProps

export default Icon
